<template>
  <div id="modifierGroups">
    <ModifierNavigation></ModifierNavigation>
    <br>
    <Datatable
      v-if="inventory"
      entity="modifier_group"
      class="datatable"
      ref="datatable"
      :parameters="{inventory: inventory.id}"
      :onRowClick="onRowClick"
      :globalActions="[
      {text: 'modifierGroups.new', method: onCreate, condition: function() { return $store.getters.loggedUserCanModifyInventory }},
      {text: 'display_priority', method: goToDisplayPriority, condition: function() { return $store.getters.loggedUserCanModifyInventory }}]"
      :rowActions="[
        {text: 'datatable.edit', method: onRowEdit},
        {text: 'datatable.delete', method: onRowDelete, condition: function() { return $store.getters.loggedUserCanModifyInventory }}
      ]">
    </Datatable>
  </div>
</template>

<script>

  import ModifierNavigation from "@/components/modifiers/Navigation";
  import Datatable from "@/components/Datatable.vue";
  import { mapActions } from "vuex";


  export default {

    name: "ModifierGroups",

    components: { ModifierNavigation, Datatable },

    data() {
      return {
        entityName: 'modifier_groups'
      }
    },

    computed: {
      inventory() {
        return this.$store.state.contextInventory
      }
    },

    async mounted() {
      this.$store.state.pageTitleTranslationKey = "inventory.modifiers_groups";
      this.$store.state.pageIcon = "/icon/menu.svg";
    },

    methods: {
      ...mapActions(["deleteInventoryEntity"]),

      edit(id) {
        this.$router.push({ path: '/modifier-groups/edit', query : Object.assign({id : id, inventory: this.inventory.id}, this.$route.query) });
      },
      onCreate() {
        this.edit(null)
      },
      onRowClick(row) {
        this.edit(row.id);
      },
      onRowEdit(row) {
        this.edit(row.id)
      },
      goToDisplayPriority() {
        this.$router.push({ path: '/modifier-groups/priority', query : Object.assign({inventory: this.inventory.id}, this.$route.query) });
      },
      async onRowDelete(row) {
        await this.deleteInventoryEntity({entity: this.entityName, inventory: this.inventory.id, id: row.id});
        this.$refs.datatable.query();
      }
    }
  }
</script>

<style lang="scss" scoped>

</style>
